import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #FBF4EC 0%, #F5EDE4 60%, #EFE5D9 100%)'
  }} data-id="element-233">
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(196, 181, 253, 0.35)'
    }} data-id="element-234"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(252, 211, 211, 0.35)'
    }} data-id="element-235"></div>

      {/* Attention Badge */}
      <div className="relative bg-white border border-[#E8D5C4] text-[#9D4D4D] font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-236">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#D97570] animate-pulse" data-id="element-237"></span>
        <span className="hidden sm:inline" data-id="element-238">
          🧘‍♀️ PARA INSTRUCTORAS DE PILATES CANSADAS DE IMPROVISAR CLASES
        </span>
        <span className="sm:hidden" data-id="element-239">PARA INSTRUCTORAS DE PILATES</span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black max-w-6xl text-[38px] leading-[1.05] sm:text-7xl md:text-8xl sm:leading-[1.02] mb-4 sm:mb-6 tracking-tight" style={{
      color: '#2A2438'
    }} data-id="element-240">
        Todo tu año de{' '}
        <span className="text-transparent bg-clip-text" style={{
        backgroundImage: 'linear-gradient(90deg, #8B6FBF 0%, #D98AA8 100%)'
      }} data-id="element-241">
          Pilates resuelto.
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/60 sm:backdrop-blur-sm sm:border sm:border-[#E8D5C4] sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm" style={{
      color: '#5C5470',
      borderLeftColor: '#8B6FBF'
    }} data-id="element-242">
        <span className="font-bold" style={{
        color: '#8B6FBF'
      }} data-id="element-243">
          MEGAPACK PILATES LISTO
        </span>{' '}
        — el sistema "Abrir y Enseñar" con 6 tomos, 60+ clases y 6 bonos para
        Reformer, Mat y Poblaciones Especiales.{' '}
        <span className="hidden sm:inline font-semibold" style={{
        color: '#2A2438'
      }} data-id="element-244">
          Sin improvisar. Sin sacrificar tus fines de semana.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[300px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-4 sm:mb-8" data-id="element-245">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(196, 181, 253, 0.25)'
      }} data-id="element-246"></div>
        <img src="https://cdn.magicpatterns.com/uploads/wb9NtNCQ17ADTxz8Vm5pUc/15002B_CLIENTE_SODDISFATTI_(5).png" alt="MEGAPACK PILATES LISTO — Kit Integral de Movimiento" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(90,70,120,0.25)]" width={500} height={500} fetchPriority="high" loading="eager" decoding="async" data-id="element-247" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-248">
        <div className="flex items-center gap-2" data-id="element-249">
          <span className="text-sm sm:text-lg" style={{
          color: '#E0A52E'
        }} data-id="element-250">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-xs sm:text-base font-medium" style={{
          color: '#5C5470'
        }} data-id="element-251">
            4.9/5 · +800 reseñas verificadas
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-3 py-1 rounded-full border" style={{
        color: '#A0651D',
        backgroundColor: '#FDF4E3',
        borderColor: '#E8D5C4'
      }} data-id="element-252">
          🔥 62 instructoras eligieron este Kit hoy
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white" style={{
      backgroundColor: '#0F8B6F'
    }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0B6E58'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#0F8B6F'} data-id="element-253">
        🚀 ¡SÍ, QUIERO EL MEGAPACK!
      </a>

      {/* Trust badges */}
    </section>;
}